<template>
  <transition name="fade">
    <div
      :class="is_mobile ? 'tag_icon_mobile' : 'tag_icon'"
      :style="{
        top: tag_position.clientY + 15 + 'px',
        display: tag_position.clientY != 0 ? 'block' : 'none',
        left: tag_position.clientX + 'px',
      }"
      @click.stop.prevent=""
      v-if="tag_position.clientY != 0"
    >
      <div class="popover-menu">
        <div class="tag_icon_search">
          <el-row :gutter="4">
            <el-col :span="20" :style="{ width: me.language != 'en' ? '83.33333%' : '79%' }">
              <el-input placeholder="" prefix-icon="el-icon-search" v-model="search" :class="search ? '' : 'empty'">
              </el-input>
            </el-col>
            <el-col :span="4">
              <span @click.stop.prevent="delete_tag_icon" class="delete_btn">
                {{ $t('components.Icon.remove') }}
              </span>
            </el-col>
          </el-row>
        </div>
        <div class="tag_icon_list">
          <div v-if="recent_tags.length && !search">
            <p>{{ $t('components.Icon.recent') }}</p>
            <div class="tag_icon_list_item">
              <span v-for="(item, idx) in recent_tags" :key="idx" @click="icon_selected(item)">{{ item }}</span>
            </div>
          </div>
          <div v-if="filter_tag_icon.length">
            <div v-for="(icon, index) in filter_tag_icon" :key="index">
              <p>{{ icon.name }}</p>
              <div class="tag_icon_list_item">
                <span
                  v-for="(item, idx) in icon.children"
                  :key="idx"
                  @click="icon_selected(item.emoji)"
                  :title="me.language != 'en' ? item.zh_name : item.en_name"
                  >{{ item.emoji }}</span
                >
              </div>
            </div>
          </div>
          <div v-else>
            <p>{{ $t('components.Icon.no_result') }}</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import DBUtil from '../utils/DBUtil'
export default {
  name: 'tagIcon',
  data() {
    return {
      tag_position: {
        clientX: 0,
        clientY: 0,
      },
      search: '',
      tag_name: '',
      me: this.$store.state.me,
    }
  },
  computed: {
    is_mobile() {
      return this.$store.state.is_mobile
    },
    emojis() {
      return this.$store.state.emojis
    },
    //TODO ??? 先放data里
    // me() {
    //   return this.$store.state.me;
    // },
    recent_tags() {
      return this.$store.state.recent_tags
    },
    filter_tag_icon() {
      const { search } = this
      const { emojis } = this.$store.state
      const res = emojis.filter(({ en_name, zh_name }) => {
        if (en_name.toLowerCase().indexOf(search.toLowerCase().trim()) >= 0) return true
        if (this.isLetter(zh_name)) {
          zh_name = zh_name.toLowerCase()
        }
        if (zh_name.indexOf(search.toLowerCase().trim()) >= 0) return true
        return false
      })

      let category = {}
      let search_result = []
      res.forEach((emoji) => {
        category[this.me.language != 'en' ? emoji.zh_category : emoji.en_category] =
          category[this.me.language != 'en' ? emoji.zh_category : emoji.en_category] || []
        category[this.me.language != 'en' ? emoji.zh_category : emoji.en_category].push(emoji)
      })

      for (const i in category) {
        search_result.push({
          name: i,
          children: category[i],
        })
      }
      return search_result
    },
  },
  methods: {
    show(value, tag_name, type) {
      const { emojis } = this.$store.state
      this.tag_position = value

      let { clientY } = value
      if (clientY == 0) {
        return
      }
      if (value.clientY > window.innerHeight - 240) {
        value.clientY = window.innerHeight - 330
      }

      if (!type) {
        this.tag_position.clientX = document.querySelector('.el-container').offsetLeft
      }
      this.tag_name = tag_name
      if (!emojis.length) {
        this.$store.dispatch('get_emojis')
      }
    },
    icon_selected(emoji) {
      let vm = this
      DBUtil.changeTagIcon(vm.tag_name, emoji).then((res) => {
        console.log(res)
        // 关闭标签表情
        vm.show({ clientY: 0 }, '')
        if (res) {
          // 添加进最近表情(如果是添加表情)
          if (emoji && emoji != -1) {
            vm.$store.commit('set_recent_tags', emoji)
          }
          // 重加载标签
          vm.$store.dispatch('loadTags')
          // 重加载置顶标签
          vm.$store.dispatch('loadPinnedTags')
        } else {
          vm.$confirm(this.$t('components.only_pro.tips.content'), this.$t('components.TagTree.change_tag_icon'), {
            confirmButtonText: this.$t('components.only_pro.tips.confirm'),
            customClass: 'confirm',
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          })
            .then(() => {
              vm.$store.commit('setSelectedSource', 'membership')
              vm.$emit('tag-clicked', 'from=tagicon_change')
            })
            .catch(() => {})
          return
        }
      })

      // vm.$http
      //   .post("/api/tag/icon", {
      //     tag: vm.tag_name,
      //     icon_type: emoji ? "emoji" : null,
      //     icon_value: emoji ? emoji : -1,
      //   })
      //   .then((response) => {
      //     if (response.data && response.data.code === -1) {
      //       vm.$message.error(response.data.message);
      //     } else if (response.data && response.data.code === 0) {
      //       // 关闭标签表情
      //       vm.show({ clientY: 0 }, "");
      //       // 添加进最近表情(如果是添加表情)
      //       if(emoji){
      //          vm.$store.commit("set_recent_tags", emoji);
      //       }
      //       // 重加载标签
      //       vm.$store.dispatch("loadTags");
      //       // 重加载置顶标签
      //       vm.$store.dispatch("loadPinnedTags");
      //     }
      //   });
    },
    delete_tag_icon() {
      this.icon_selected(-1) //-1表示强制ICON为空 null 表示ICON未设置 -> 此时可能应用彩蛋ICON
    },
    isLetter(str) {
      return /^[a-zA-Z]+$/.test(str)
    },
  },
}
</script>
<style scoped>
* {
  padding: 0;
  margin: 0;
}
.tag_icon,
.tag_icon_mobile {
  position: fixed;
  width: 316px;
  height: 306px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: none;
  left: 350px;
  z-index: 99999;
  background: var(--glassBg) !important;
  backdrop-filter: blur(12px) saturate(190%) contrast(50%) brightness(130%);
}
.tag_icon_search {
  padding: 13px 12px;
  padding-bottom: 5px;
}
.tag_icon_list {
  height: 255px;
  overflow-y: scroll;
  padding: 0px 12px;
}
.tag_icon_search .delete_icon {
  font-size: 18px;
  color: gray;
  position: absolute;
  top: 5px;
  cursor: pointer;
}
/deep/ .tag_icon_search .el-input__inner {
  height: 30px;
  line-height: 30px;
}
/deep/ .tag_icon_search .el-input__icon {
  line-height: 30px;
}
/deep/ .tag_icon_search .empty .el-input__inner {
  background: #efefef;
}

.tag_icon_list span {
  user-select: none;
  transition: background 20ms ease-in 0s;
  cursor: pointer;
  border-radius: 3px;
  width: 32px;
  height: 32px;
  font-size: 24px;
  text-align: center;
  display: inline-block;
  font-family: Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}
.tag_icon_list span:hover {
  background: rgba(55, 53, 47, 0.08);
}
.tag_icon_list p {
  font-size: 14px;
  color: #9d9d9d;
  margin: 5px 0;
  margin-top: 20px;
}
.delete_btn {
  font-size: 14px;
  padding: 5px 7px;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  color: #9d9d9d;
  position: relative;
  top: 4px;
  cursor: pointer;
}
</style>
